import React from 'react';
import BiotechIcon from '@mui/icons-material/Biotech';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "Bollgard 3 RRFlex"' },
  { key: 'hasCry1Ac', label: 'Cry1Ac', type: 'boolean', helperText: 'Bollgard I / Ingard' },
  { key: 'hasCry2Ab', label: 'Cry2Ab', type: 'boolean', helperText: 'Bollgard II' },
  { key: 'hasVip3A', label: 'Vip3A', type: 'boolean', helperText: 'Bollgard 3' },
  { key: 'hasRoundupReady', label: 'Roundup Ready', type: 'boolean' },
  { key: 'hasRoundupReadyFlex', label: 'Roundup Ready Flex', type: 'boolean' },
  { key: 'hasXtendFlex', label: 'XtendFlex', type: 'boolean', helperText: 'Dicamba + glyphosate tolerance' },
  { key: 'sortIndex', label: 'Sort Index', required: true, type: 'number' },
];

const GeneStackManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Gene Stack Management"
    icon={<BiotechIcon />}
    apiPath="/api/gene-stacks"
    fields={fields}
    entityLabel="Gene Stack"
  />
);

export default GeneStackManagement;
